import { React, useRef, useEffect, useState } from 'react';
import Fab from '@mui/material/Fab';
import Button from '@mui/material/Button';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import StyledRadio from '../StyledExtensions/StyledRadio'
import StyledCheckbox from '../StyledExtensions/StyledCheckbox'
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import RemoveIcon from '@mui/icons-material/Remove';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';

export default function EstimateWizard(props) {
    const [activeStep, setActiveStep] = useState(0);
    const [containerType, setContainerType] = useState('');
    const [containerSize, setContainerSize] = useState('');
    const [containerFullness, setContainerFullness] = useState(100);
    const [customPackQuantity, setCustomPackQuantity] = useState('');
    const [contentsCans, setContentsCans] = useState(false);
    const [contentsBottles, setContentsBottles] = useState(false);
    const [contents2Liters, setContents2Liters] = useState(false);
    const [contentsLargerCansBottles, setContentsLargerCansBottles] = useState(false);
    const [estimateDescription, setEstimateDescription] = useState('');
    const [quantity, setQuantity] = useState(1);

    useEffect(() => {
        // fires when containerType changes
        if (containerType !== '') {
            handleNext() // setState callback
        }
    }, [containerType]); 

    useEffect(() => {
        // fires when containerSize changes
        if (containerSize !== '') {
            if (containerType === 'Garbage Bag') {
                handleNext();
            }
            else if (containerType === 'Original Package') {
                handleNext();
            }
        }
    }, [containerSize]); 

    const handleNext = () => {
        if (activeStep === 0 && (containerType === 'Plastic Grocery Bag' || containerType === 'Paper Grocery Bag')) {
            setContainerSize('1 size fits all');
            setActiveStep((prevActiveStep) => prevActiveStep + 2); // skips the next step
        }
        else if (activeStep === 1 && (containerType === 'Custom Container'))
        {
            setActiveStep(4); // goes to the summary
        }
        else if (activeStep === 1 && (containerType === 'Original Package' && containerSize !== 'otherpack')) {
            setActiveStep(4); // goes to the summary
        }
        else if (activeStep === 2 && (containerType === 'Original Package' && containerSize == 'otherpack')) {
            setActiveStep(4); // goes to the summary
        }
        else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
        
    };

    const handleBack = () => {
        if (activeStep === 2 && (containerType === 'Plastic Grocery Bag' || containerType === 'Paper Grocery Bag')) {
            setActiveStep((prevActiveStep) => prevActiveStep - 2);
        }
        else if (activeStep === 4 && (containerType === 'Custom Container'))
        {
            setActiveStep(1); // back to quantity
        }
        else if (activeStep === 4 && (containerType === 'Original Package' && containerSize !== 'otherpack')) {
            setActiveStep(1); // back to select pack type
        }
        else if (activeStep === 4 && (containerType === 'Original Package' && containerSize === 'otherpack')) {
            setActiveStep(2); // back to select pack size
        }
        else {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
       
    };

    const howFullMarks = [
        {
            value: 25,
            label: '25%',
        },
        {
            value: 50,
            label: '50%',
        },
        {
            value: 75,
            label: '75%',
        },
        {
            value: 100,
            label: '100%',
        },
    ];

    function howFullValuetext(value) {
        return `{value}%`;
    }


    const handleReset = () => {
        setActiveStep(0);
    };

    function buildSizeOrFullnessLable() {
        if (containerSize === 'otherpack') {
            return "Pack Size";
        }
        else if (containerType === "Original Package")
        {
            return "100% Full";
        }
        else if (containerType === "Custom Container") {
            return "100% Full";
        }
        else {
            return "How Full";
        }
    }

    function buildContentTypesCaption() {
        if (activeStep === 4) {
            if (containerType === "Original Package" || containerType === 'Custom Container') {
                return 'Cans/Bottles'
            }

        }
        
            if (containerType === "Plastic Grocery Bag" || containerType === 'Paper Grocery Bag' || containerType === 'Garbage Bag') {
                let label = '';
                let typeCount = 0;
                if (contentsCans) {
                    label = '12 oz cans'
                    typeCount++;
                }

                if (contentsBottles) {
                    label = '12 oz bottles'
                    typeCount++;
                }

                if (contentsLargerCansBottles) {
                    label = 'larger cans/bottles'
                    typeCount++;
                }

                if (contents2Liters) {
                    label = '2 Liters'
                    typeCount++;
                }

                if (typeCount > 1) {
                    label = 'Mix';
                }

                return label;
            }
        
    }

    const steps = [
        {
            label: 'Select a Container Type',
            caption: containerType,
            contents: buildContainerType()
        },
        {
            label: 'Select a Size',
            caption: containerSize,
            contents: buildSizePanel(),
        },
        {
            label: buildSizeOrFullnessLable(),
            caption: '',
            contents: buildCustomSizeOrFullness()

        },
        {
            label: 'Contents',
            caption: buildContentTypesCaption(),
            contents: buildContentTypes(),
        },
        {
            label: 'Summary',
            caption: '',
            contents: showSummary()
        },
    ]

    function showSummary() {
        let quantityPanel = (
            <div className={styles.EstimateSummaryItemQuantity}>
                <Fab size="small" sx={{ fontSize: 40, marginBottom: '15px', backgroundColor: 'var(--sipzee-yellow-2)' }}
                    onClick={(e) => decrementQuantity(e)}
                    aria-label="add">
                    <RemoveIcon sx={{ fontSize: 40 }} />
                </Fab>
                <div style={{display:'flex', flexDirection:'column'} }>
                    <div style={{ alignSelf: 'center' }} >Quantity</div>
                    <div style={{ alignSelf: 'center' }}>{quantity}</div>
                </div>
                <Fab size="small" sx={{ fontSize: 40, marginBottom: '15px', backgroundColor: 'var(--sipzee-green)' }}
                    onClick={(e) => incrementQuantity(e)}
                    aria-label="add">
                    <AddIcon sx={{ fontSize: 40 }} />
                </Fab>
            </div>);

        let summaryPanel = buildSummary();
        return (<div>
            <div>{quantityPanel}</div>
            <div style={{textAlign:'center'} }> {summaryPanel}</div>
        </div>);
    }

    function containerTypeSelected(type) {
        setContainerSize('');
        setContainerType(type);
        
        //window.setTimeout(function () {
        //   
        //}, 100);
        
    }

    function canContinue() {
        if (activeStep === 0) {
            if (containerType !== '') {
                return true;
            }
        }

        if (activeStep === 1) {
            if (containerType === 'Custom Container') {
                return validatePackSize().isValid;
            }

            if (containerSize !== '') {
                return true;
            }
        }

        if (activeStep === 2) {
            if (containerSize !== 'otherpack') {
                return true; // slider always has a value
            }

            if (containerSize === 'otherpack') {
                return validatePackSize().isValid;
            }
        }

        if (activeStep === 3) {
            if (contentsCans || contentsBottles || contentsLargerCansBottles || contents2Liters) {
                return true;
            }

        }

        if (activeStep === steps.length - 1) {
            // summary page. everything should have been validate prior to this point
            return true;
        }

        return false;
    }

    function isValid() {
        return false;
    }

    function buildContentTypes() {
        return (
            <div>
                <div className={styles.cardQuestion}> What is in the bag?</div>
                <div>Check all that apply</div>
                <Box display="flex"
                    justifyContent="center"
                    alignItems="center"
                    noValidate
                    flexDirection="column"
                    flexWrap='wrap'
                    autoComplete="off">
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContentsCans(!contentsCans)}>
                        {<StyledCheckbox checked={contentsCans} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                                <img src='/images/PickupWizard/12OzCan.jpg' style={{ height: '100px', alignSelf: 'center' }} />
                                <div style={{ alignSelf: 'center' }}>12 oz cans</div>
                            </div>
                        </Paper>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContentsBottles(!contentsBottles)}>
                        {<StyledCheckbox checked={contentsBottles} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                                <img src='/images/PickupWizard/12OzBottle.jpg' style={{ height: '100px', alignSelf: 'center' }} />
                                <div style={{ alignSelf: 'center' }}>12 oz bottles</div>
                            </div>
                        </Paper>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContentsLargerCansBottles(!contentsLargerCansBottles)}>
                        {<StyledCheckbox checked={contentsLargerCansBottles} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                                <img src='/images/PickupWizard/LargerCansBottles.jpg' style={{ height: '100px', alignSelf: 'center' }} />
                                <div style={{ alignSelf: 'center' }}>Larger cans & bottles</div>
                            </div>
                        </Paper>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContents2Liters(!contents2Liters)}>
                        {<StyledCheckbox checked={contents2Liters} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                                <img src='/images/PickupWizard/2 Liter Bottle.png' style={{ height: '100px', alignSelf: 'center' }} />
                                <div style={{ alignSelf: 'center' }}>2 Liter bottles</div>
                            </div>
                        </Paper>
                    </div>
                </Box>
            </div>);
    }

    function validatePackSize() {
        let isValid = true;
        let errors = {};

        if (customPackQuantity.trim() == '') {
            // no message initially
            isValid = false;
        }
        else if (isNaN(customPackQuantity)) {
            isValid = false;
            if (containerSize === 'otherpack') {
                errors["Quantity"] = 'The Pack size must be a number';
            }
            else if (containerType === 'Custom Container') {
                errors["Quantity"] = 'Must be a number';
            }
            
        }
        else if (parseInt(customPackQuantity) <= 0) {
            isValid = false;
           
            if (containerSize === 'otherpack') {
                errors["Quantity"] = 'The Pack size must more than zero';
            }
            else if (containerType === 'Custom Container') {
                errors["Quantity"] = 'Must be  more than zero';
            }
        }

        return {
            isValid: isValid,
            errors: errors
        }
    }

    function buildContainerType() {
       return <Box display="flex"
            justifyContent="center"
            alignItems="center"
            noValidate
            flexDirection="column"
            flexWrap='wrap'
            autoComplete="off">
            <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => containerTypeSelected('Garbage Bag')}>
                {<StyledRadio checked={containerType === 'Garbage Bag'} style={{ alignSelf: 'center' }} />}
                <Paper className={styles.paperImageCard}>
                    <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                        <img src='/images/PickupWizard/Garbage Bag.jpg' style={{ width: '100px', alignSelf: 'center' }} />
                        <div style={{ alignSelf: 'center' }}>Garbage Bag</div>
                    </div>
                </Paper>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5px' }} onClick={() => containerTypeSelected('Plastic Grocery Bag')}>
                {<StyledRadio checked={containerType === 'Plastic Grocery Bag'} style={{ alignSelf: 'center' }} />}
                <Paper className={styles.paperImageCard}>
                    <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                        <img src='/images/PickupWizard/Plastic Grocery Bag.jpg' style={{ width: '100px', alignSelf: 'center' }} />
                        <div style={{ alignSelf: 'center' }}>Plastic Grocery Bag</div>
                    </div>
                </Paper>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5px' }} onClick={() => containerTypeSelected('Paper Grocery Bag')}>
                {<StyledRadio checked={containerType === 'Paper Grocery Bag'} style={{ alignSelf: 'center' }} />}
                <Paper className={styles.paperImageCard}>
                    <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                        <img src='/images/PickupWizard/Paper Grocery Bag.jpg' style={{ width: '100px', alignSelf: 'center' }} />
                        <div style={{ alignSelf: 'center' }}>Paper Grocery Bag</div>
                    </div>
                </Paper>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5px' }} onClick={() => containerTypeSelected('Original Package')}>
                {<StyledRadio checked={containerType === 'Original Package'} style={{ alignSelf: 'center' }} />}
                <Paper className={styles.paperImageCard}>
                    <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                        <img src='/images/PickupWizard/Original Package.png' style={{ width: '100px', alignSelf: 'center' }} />
                        <div style={{ alignSelf: 'center' }}>Original Package</div>
                    </div>
                </Paper>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5px' }} onClick={() => containerTypeSelected('Custom Container')} >
                {<StyledRadio checked={containerType === 'Custom Container'} style={{ alignSelf: 'center' }} />}
                <Paper className={styles.paperImageCard}>
                    <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                        <img src='/images/PickupWizard/Custom Container.png' style={{ width: '100px', alignSelf: 'center' }} />
                        <div style={{ alignSelf: 'center' }}>Custom Container</div>
                    </div>
                </Paper>
            </div>
        </Box>
    }

    function buildCustomSizeOrFullness() {
        if (containerSize === 'otherpack') {
            return (
                <div>
                    <div className={styles.cardQuestion}>
                        What size of pack is it?
                    </div>
                    <div>
                        <TextField autoComplete='off' label="Pack Size" error={validatePackSize().errors['Quantity'] !== undefined} onChange={(e) => setCustomPackQuantity(e.target.value)} value={customPackQuantity} variant="outlined" style={{ maxWidth: '175px' }} inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} />
                        <div style={{ color: 'var(--sipzee-red)' }}> {validatePackSize().errors['Quantity'] !== undefined ? validatePackSize().errors['Quantity'] : ''}</div>
                    </div>
                </div>
                )
        }
        else {
            return (
                <div>
                    <div className={styles.cardQuestion}>
                        How full is the {containerType}?
                    </div>
                    <Slider
                        aria-label="Fullness"
                        defaultValue={containerFullness}
                        getAriaValueText={howFullValuetext}
                        step={null}
                        valueLabelDisplay="auto"
                        onChange={(event, newValue) => setContainerFullness(newValue) }
                        marks={howFullMarks}
                    />
                </div>
            )
        }
       
    }

    function buildSizePanel() {
        if (containerType === 'Garbage Bag') {
            return (
                <Box display="flex"
                    justifyContent="center"
                    alignItems="center"
                    noValidate
                    flexDirection="column"
                    flexWrap='wrap'
                    autoComplete="off">
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContainerSize('Small')}>
                        {<StyledRadio checked={containerSize === 'Small'} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard }>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent:'center', backgroundColor: 'white' }}>
                                <img src='/images/PickupWizard/4gal.png' style={{alignSelf:'center', height:'55px'} }  />
                                <div style={{ alignSelf: 'center' }}>Small</div>
                                <div style={{ alignSelf: 'center' }}>Bathroom - About 4 gal</div>
                            </div>
                        </Paper>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContainerSize('Medium')}>
                        {<StyledRadio checked={containerSize === 'Medium'} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                                <img src='/images/PickupWizard/20-30gal.png' style={{ height: '70px', alignSelf: 'center' }} />
                                <img src='/images/PickupWizard/Kitchen Bag.jpg' style={{ width: '100px', alignSelf: 'center' }} />
                                <div style={{ alignSelf: 'center' }}>Medium</div>
                                <div style={{ alignSelf: 'center' }}>Kitchen - About 13 gal</div>
                            </div>
                        </Paper>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContainerSize('Large')}>
                        {<StyledRadio checked={containerSize === 'Large'} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                                <img src='/images/PickupWizard/32-44gal.png' style={{ height: '85px', alignSelf: 'center' }} />
                                <img src='/images/PickupWizard/large garbage bag.jpg' style={{ width: '100px', alignSelf: 'center' }} />
                                <div style={{ alignSelf: 'center' }}>Large</div>
                                <div style={{ alignSelf: 'center' }}>About 30 gal</div>
                            </div>
                        </Paper>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContainerSize('XLarge')}>
                        {<StyledRadio checked={containerSize === 'XLarge'} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                                <img src='/images/PickupWizard/50-65gal.png' style={{ height: '90px', alignSelf: 'center' }} />
                                <img src='/images/PickupWizard/xlarge garbage bag.jpg' style={{ width: '100px', alignSelf: 'center' }} />
                                <div style={{ alignSelf: 'center' }}>X-Large</div>
                                <div style={{ alignSelf: 'center' }}>About 50 gal</div>
                            </div>
                        </Paper>
                    </div>
                </Box>
                )
        }
        else if (containerType === 'Custom Container') {
            return (
                <div>
                    <div className={styles.cardQuestion}>
                        How many returnables in container?
                    </div>
                    <div>
                        <TextField autoComplete='off' label="Quantity" error={validatePackSize().errors['Quantity'] !== undefined} onChange={(e) => setCustomPackQuantity(e.target.value)} value={customPackQuantity} variant="outlined" style={{ maxWidth: '175px' }} inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} />
                        <div style={{ color: 'var(--sipzee-red)' }}> {validatePackSize().errors['Quantity'] !== undefined ? validatePackSize().errors['Quantity'] : ''}</div>
                    </div>
                </div>
            
            )
        }
        else if (containerType === 'Original Package') {
            return (
                <Box display="flex"
                    justifyContent="center"
                    alignItems="center"
                    noValidate
                    flexDirection="column"
                    flexWrap='wrap'
                    autoComplete="off">
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContainerSize('6 Pack')}>
                        {<StyledRadio checked={containerSize === '6 Pack'} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard}>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', backgroundColor: 'white' }}>
                                <img src='/images/PickupWizard/6pack.png' style={{ width: '100px', alignSelf: 'center' }} />
                                <div style={{ alignSelf: 'center' }}>6 Pack</div>
                            </div>
                        </Paper>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContainerSize('12 Pack')}>
                        {<StyledRadio checked={containerSize === '12 Pack'} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                              
                                <img src='/images/PickupWizard/12pack.png' style={{ width: '100px', alignSelf: 'center' }} />
                                <div style={{ alignSelf: 'center' }}>12 Pack</div>
                            </div>
                        </Paper>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContainerSize('15 Pack')}>
                        {<StyledRadio checked={containerSize === '15 Pack'} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                               
                                <img src='/images/PickupWizard/15pack.png' style={{ width: '100px', alignSelf: 'center' }} />
                                <div style={{ alignSelf: 'center' }}>15 Pack</div>
                            </div>
                        </Paper>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContainerSize('24 Pack')}>
                        {<StyledRadio checked={containerSize === '24 Pack'} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
                             
                                <img src='/images/PickupWizard/24pack.png' style={{ width: '100px', alignSelf: 'center' }} />
                                <div style={{ alignSelf: 'center' }}>24 Pack</div>
                            </div>
                        </Paper>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContainerSize('30 Pack')}>
                        {<StyledRadio checked={containerSize === '30 Pack'} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>

                                <img src='/images/PickupWizard/30pack.png' style={{ width: '100px', alignSelf: 'center' }} />
                                <div style={{ alignSelf: 'center' }}>30 Pack</div>
                            </div>
                        </Paper>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setContainerSize('otherpack')}>
                        {<StyledRadio checked={containerSize === 'otherpack'} style={{ alignSelf: 'center' }} />}
                        <Paper className={styles.paperImageCard}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>

                                <img src='/images/PickupWizard/OtherPack.png' style={{ width: '100px', alignSelf: 'center' }} />
                                <div style={{ alignSelf: 'center' }}>Other Size</div>
                            </div>
                        </Paper>
                    </div>
                </Box>
            )
        }
    }

    function buildSummary() {
        let fullnessDesc = null;
        let containerDesc = null;
        let contentsCansDesc = null;
        let contentsBottlesDesc = null;
        let contentsLargerDesc = null;
        let contents2LitersDesc = null;

        if (containerType == 'Plastic Grocery Bag' || containerType == 'Paper Grocery Bag' || containerType == 'Garbage Bag') {
            if (contentsCans) {
                contentsCansDesc = <div style={{ marginLeft: '20px' }}>12 oz cans</div>;
            }

            if (contentsBottles) {
                contentsBottlesDesc = <div style={{ marginLeft: '20px' }}>12 oz bottles</div>;
            }

            if (contentsLargerCansBottles) {
                contentsLargerDesc = <div style={{ marginLeft: '20px' }}>Larger cans/bottles</div>;
            }

            if (contents2Liters) {
                contents2LitersDesc = <div style={{ marginLeft: '20px' }}>2 Liter bottles</div>;
            }

            fullnessDesc = (<div>
                {containerFullness}% Full {(containerType === 'Garbage Bag' ? containerSize : '')} {containerType} of:
            </div>);

        }
        else if (containerType === 'Original Package') {
            if (containerSize === 'otherpack') {
                containerDesc = <div>{parseInt(customPackQuantity)} Pack</div>
            }
            else {
                containerDesc = <div>{parseInt(containerSize)}</div>
            }

        }
        else if (containerType === 'Custom Container') {
            containerDesc = <div>Custom container of {parseInt(customPackQuantity)} bottles/cans</div>
        }

        return (
            <div>
              

                {containerDesc}
                {fullnessDesc}
                {contentsCansDesc}
                {contentsBottlesDesc}
                {contentsLargerDesc}
                {contents2LitersDesc}
            </div>   
         )
    }

    function incrementQuantity(e, containerId) {
        setQuantity(quantity + 1);
    }


    function decrementQuantity(e, containerId) {
        if (quantity >= 2) {
            setQuantity(quantity - 1);
        }
    }

    function onAccept() {
        let estimate = {

        }

        estimate.quantity = quantity;

        if (containerType == 'Plastic Grocery Bag' || containerType == 'Paper Grocery Bag' || containerType == 'Garbage Bag') {
            estimate.containerType = containerType;
            estimate.containerFullness = containerFullness;
            estimate.containerSize = (containerType === 'Garbage Bag' ? containerSize : '');
            estimate.contentsCans = contentsCans;
            estimate.contentsBottles = contentsBottles;
            estimate.contents2Liters = contents2Liters;
            estimate.contentsLargerCansBottles = contentsLargerCansBottles;
            estimate.customPackQuantity = 0;
        }
        else if (containerType === 'Original Package' || containerType === 'Custom Container') {
            estimate.containerType = containerType;
            estimate.containerFullness = 100;
            estimate.containerSize = containerSize;
            estimate.contentsCans = false;
            estimate.contentsBottles = false;
            estimate.contents2Liters = false;
            estimate.contentsLargerCansBottles = false;

            estimate.customPackQuantity = 0;

            if (containerSize === 'otherpack') {
                estimate.customPackQuantity = parseInt(customPackQuantity);
            }
            else if (containerType === 'Custom Container') {
                estimate.customPackQuantity = parseInt(customPackQuantity);
            }

        }

        estimate.summary = buildSummary();
        
        //const [containerType, setContainerType] = useState('');
        //const [containerSize, setContainerSize] = useState('');
        //const [containerFullness, setContainerFullness] = useState(100);
        //const [customPackQuantity, setCustomPackQuantity] = useState('');
        //const [contentsCans, setContentsCans] = useState(false);
        //const [contentsBottles, setContentsBottles] = useState(false);
        //const [contents2Liters, setContents2Liters] = useState(false);
        //const [contentsLargerCansBottles, setContentsLargerCansBottles] = useState(false)
        props.onAccept(estimate);
    }

    return <div>
        <Dialog
            open={true}
            maxWidth="330px"
           
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent style={{width:'330px'} }>

                <Stepper activeStep={activeStep} orientation="vertical">
                    {steps.map((step, index) => (
                        <Step key={step.label}>
                            <StepLabel
                                optional={
                                  
                                        <Typography variant="caption">{step.caption}</Typography>
                                    
                                }
                            >
                                {step.label}
                            </StepLabel>
                            <StepContent>
                                <div>{step.contents}</div>
                                <Box sx={{ mb: 2 }}>
                                    <div style={{display:'flex', justifyContent:'space-between'} }>
                                        <Button
                                            variant="outlined"
                                            disabled={index === 0}
                                            onClick={handleBack}
                                            sx={{ mt: 1, mr: 1 }}
                                            style={{ visibility: (activeStep === 0 ? 'hidden' : 'visible') }}
                                        >
                                            <ArrowBackIosIcon /> Prev
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={handleNext}
                                            sx={{
                                                mt: 1,
                                                mr: 1,
                                            

                                            }}
                                            disabled={!canContinue()}
                                            style={{ display: (activeStep === steps.length - 1 ? 'none' : 'block') } }
                                        >
                                          Continue
                                        </Button>
                                       
                                    </div>
                                </Box>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>


            </DialogContent>
            <DialogActions style={{justifyContent:'flex-start'} }>
                <Button variant='outlined' onClick={props.onClose }>
                    Cancel
                </Button>
                <Button variant='contained' onClick={onAccept} style={{ marginLeft: 'auto', display: (activeStep === steps.length - 1 ? 'block' : 'none'), backgroundColor:'var(--sipzee-green)'} }>
                    Add to Order
                </Button>
            </DialogActions>
        </Dialog>
    </div>
}